import { stripPhoneNumber } from 'utils/phoneNumber'

export const normalizePhoneNumberForValidation = phoneNumber => {
  const digits = stripPhoneNumber(phoneNumber || '').replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1)
  }
  return digits.length > 0 ? digits : ''
}

export const consumerProfile = user => ({
  firstName: user.firstName,
  lastName: user.lastName,
  email: user.email,
  phoneNumber: normalizePhoneNumberForValidation(user.phoneNumber),
})

// The logged-in consumer is always the contact. They are only seeded as a paid
// participant on Adults Only events; elsewhere they may be a guardian registering
// juniors, so participants start empty and the user adds the actual attendees.
export const authenticatedConsumerParticipants = (
  user,
  isAuthenticatedConsumer,
  groupEvent,
) =>
  isAuthenticatedConsumer && groupEvent?.tags?.includes('Adults Only')
    ? [{ ...consumerProfile(user), type: 'Adult' }]
    : []
